import { styled, Input, Icon as IconBase } from '@innowise-group/mui-kit';
import { NumberInput } from '@shared-mui-components';

export const DisabledInput = styled(Input)``;

export const FullNumberInput = styled(NumberInput)`
  &.MuiTextField-root {
    width: 100% !important;
  }
`;

export const FullInput = styled(Input)`
  &.MuiTextField-root {
    width: 100% !important;
  }
`;

export const DatePickerContainer = styled.div`
  & .MuiTextField-root {
    width: 100% !important;
  }
  & .MuiOutlinedInput-root {
    padding-right: 2px;
  }
`;

export const FormContainer = styled.div`
  display: grid;
  flex: 1;
  gap: 1rem;
  row-gap: 4px;
  grid-template-columns: 1fr 1fr 1fr;
`;

export const ColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 5px;
  flex: 1;
`;

export const CheckboxesColumn = styled(ColumnContainer)`
  gap: 1.5rem;
  flex: 1;
`;

export const FieldsGroup = styled(ColumnContainer)`
  flex: 0;
`;

export const GroupLabel = styled.span`
  color: ${({ theme }) => theme.palette.general.darkGrey[60]};
  ${({ theme }) => theme.fonts.primary[60]}
`;

export const CommentContainer = styled.div`
  grid-column: 1 / -1;
`;

export const SalaryIconContainer = styled.div`
  margin-top: 3px;
  cursor: pointer;

  & svg:hover {
    fill: transparent;

    & path {
      stroke: ${({ theme }) => theme.palette.general.darkGrey[80]};
    }
  }
`;

export const LabelWithIconWrapper = styled.div`
  display: flex;
  column-gap: 8px;
`;

export const NonBillableWarning = styled.div`
  display: flex;
  padding: 1rem;
  align-items: center;
  gap: 0.75rem;
  align-self: stretch;
  border-radius: 10px;
  border: 1px solid #fee6d8;
  background: #fef2ec;
  grid-column: 1/4;
  color: ${({ theme }) => theme.palette.general.darkGrey[100]};
  font-size: 1rem;
  font-weight: 400;
  margin-bottom: 16px;
`;

export const AlertIcon = styled(IconBase)`
  width: 20px;
  height: 20px;
`;
